import React, { useState, useEffect } from "react";
import {
  Stack,
  IconButton,
  Card,
  CardContent,
  Button,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import ContactForm from "./ContactForm";
import { MWhatsNewsService } from "../../services/MWhatsNewsService";
import dayjs from "dayjs";
import { globalService } from "../../services/GlobalService";
import ConfirmDialog from "../helper/ConfirmDialog";

const WhatsNew = (props: any) => {
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '', onConfirm: () => { }})
  const [mWhatNews, setMWhatsNews] = useState([]);
  const navigate = useNavigate();


  useEffect(() => {
    getMWhatsNews();
  }, []);

  const columns: GridColDef[] = [
    { field: "WhatsNewTitle", headerName: "Whats New Title", flex: 1, },
    // {
    //   field: "WhatsNew",
    //   headerName: "What's New",
    //    flex: 1,
    //   sortable: false,
    //   renderCell: (params) => (
    //     <div
    //       dangerouslySetInnerHTML={{ __html: params.value || "" }}
    //       style={{
    //         overflow: "hidden",
    //         textOverflow: "ellipsis",
    //         whiteSpace: "nowrap",
    //         maxWidth: "100%",
    //       }}
    //     />
    //   ),
    // },
    {
      field: "CreatedOn",
      headerName: "Created On",
    flex: 1,
      valueFormatter: (params) => dayjs(params.value).format("DD-MMM-YYYY"),
    },
    {
      field: "Active",
      headerName: "Active",
flex: 1,
      renderCell: (params) => {
        return (
          <Stack>
            {params.row.Active && <DoneIcon color="secondary" />}
            {!params.row.Active && <CloseIcon />}
          </Stack>
        );
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      type: "number",
flex: 1,
      renderCell: (params) => {
        return (
          <Stack direction="row" spacing={0}>
            <IconButton
              size="small"
              color="primary"
              aria-label="add an alarm"
              onClick={() => navigate("/editWhatsNews/" + params.row.WhatsNewId)}
            >
              <EditIcon fontSize="inherit" />
            </IconButton>
            <IconButton size="small"  aria-label="delete"  color="error"
              onClick={() => {
  
                setConfirmDialog({
                  isOpen: true,
                  title: 'Are you sure to delete this WhatsNews ?',
                  subTitle: "You can't undo this operation",
                  onConfirm: () => { removeWhatsNews(params.row.WhatsNewId) }
                })
              }}>
              <DeleteIcon fontSize="inherit"  />
            </IconButton>
          </Stack>
        );
      },
    },
  ];

    const removeWhatsNews = (WhatsNewId: any) => {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false
      })
      MWhatsNewsService.remove(WhatsNewId).then((response) => {
             let result=response.data;
             if (response) {
               globalService.success(result.message);
               getMWhatsNews();
             }
           });
       }
     
  
  const getMWhatsNews = () => {
    MWhatsNewsService.getAllByActive().then((response) => {
      let result = response.data;
      setMWhatsNews(result.list);
    });
  };

  return (
    <>
      <Typography variant="h5" align="center">
        What's New
      </Typography>
      <Card>
        <CardContent>
          <Button
            variant="contained"
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => navigate("/addwhatsNews")}
          >
            Add Record
          </Button>
          <div style={{ width: "100%" }}>
            <DataGrid
              getRowId={(row) => row.WhatsNewId}
              rows={mWhatNews}
              columns={columns}
              columnHeaderHeight={30}
              //rowHeight={30}
              autoHeight={true}
              getRowHeight={() => "auto"}
              getEstimatedRowHeight={() => 200}
              //loading={loading}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns Id, the other columns will remain visible
                    WhatsNewsId: false,
                  },
                },
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              pageSizeOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardContent>
      </Card>
      <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
    </>
  );
};

export default WhatsNew;
